import { StyleSheet } from "react-native";
import { formScreen } from "../Styles/formScreen";

export default StyleSheet.create({
  ...formScreen,
  buttonEntry: {
    width: "50%",
    // alignSelf: "stretch",
    alignItems: "center",
    height: 48,
    marginTop: 24,
    padding: 8,
    borderRadius: 8,
    borderWidth: 2,
    justifyContent: "center",
    flexDirection: "row",
    alignSelf: "center",
  },
  textButton: {
    color: "#FFF",
    fontSize: 18,
    fontWeight: "bold",
  },
});
